import styled from 'styled-components'

export const ContainerConversor = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const CardResumo = styled.div`
    width: 100%;
    box-sizing: border-box;
    border: thin solid var(--border-color);
    border-radius: 8px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .CardResumo__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    .CardResumo__nome_arquivo {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        color: var(--text-color);
        min-width: 0;

        svg {
            color: var(--primary-color);
        }
    }

    .CardResumo__tags {
        display: flex;
        align-items: center;
        gap: 5px;
        flex-wrap: wrap;
    }

    .CardResumo__formato {
        font-size: 13px;
        color: var(--text-color-light);

        b {
            color: var(--text-color);
        }
    }
`;

export const ListaFeicoes = styled.div`
    width: 100%;
    box-sizing: border-box;
    border: thin solid var(--border-color);
    border-radius: 8px;
    overflow: hidden;

    .ListaFeicoes__header {
        display: grid;
        grid-template-columns: 60px 1fr 160px;
        padding: 10px 15px;
        background: var(--hover-color);
        border-bottom: thin solid var(--border-color);
        font-weight: 600;
        font-size: 13px;
        color: var(--text-color);
    }

    .ListaFeicoes__body {
        max-height: calc(100vh - 470px);
        min-height: 100px;
        overflow-y: auto;
    }

    .ListaFeicoes__row {
        display: grid;
        grid-template-columns: 60px 1fr 160px;
        padding: 8px 15px;
        border-bottom: thin solid var(--border-color);
        font-size: 13px;
        color: var(--text-color);
        align-items: center;

        :last-child {
            border-bottom: none;
        }

        &:hover {
            background: var(--hover-color);
        }
    }

    .ListaFeicoes__row__nome {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 10px;
    }

    .ListaFeicoes__row__tipo {
        display: flex;
        align-items: center;
        gap: 6px;

        svg {
            color: var(--primary-color);
        }
    }

    .ListaFeicoes__rodape {
        padding: 8px 15px;
        font-size: 12px;
        color: var(--text-color-light);
        background: var(--hover-color);
        border-top: thin solid var(--border-color);
    }
`;
